var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container flex-col flex-center"},[_c('div',{staticStyle:{"font-size":"120px","font-family":"consolas"}},[_vm._v(_vm._s(_vm.state))]),_c('div',[_vm._v(_vm._s(_vm.desc))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }